import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal,
  InMemoryInteger,
} from "pbas-vue-components";

import { i18n } from '@/plugins/i18n';

function getHeaders() {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "headers.memberdependants.id",
      type: new InMemoryString("Id"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.order",
      type: new InMemoryDecimal("Order", {
        getString: (item) => {
          if (item.Order===null || item.Order === undefined) {
            return "";
          }
          return item.Order.toString();
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.class_name",
      type: new InMemoryString("Name", {
        getString: (item) => {
          if (item.Name === undefined || item.Name === null) {
            return "";
          }
          return i18n.t("enums." + item.Name);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.widget_icon",
      type: new InMemoryString("WidgetIcon", {
        getHtml: (item, type) => {
          if (item.WidgetIcon === null || item.WidgetIcon === undefined) {
            return "";
          }
          return `<i class="v-icon notranslate mdi theme--light ${item.WidgetIcon}"></i><span style="margin-left:5px">${item.WidgetIcon}</span>`
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.member_files.size",
      type: new InMemoryInteger("Size"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.height",
      type: new InMemoryInteger("Height"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.show_to_roles",
      type: new InMemoryString("ShowTo", {
        getString: (item) => {
          if (
            item.ShowTo === null ||
            item.ShowTo === undefined ||
            !Array.isArray(item.ShowTo) ||
            item.ShowTo.length === 0
          ) {
            return "All";
          }
          return item.ShowTo.join(", ");
        },
        getHtml: (item, type) => {
          if (
            item.ShowTo === null ||
            item.ShowTo === undefined ||
            !Array.isArray(item.ShowTo) ||
            item.ShowTo.length === 0
          ) {
            return "All";
          }
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  return headers;
}
export default getHeaders;
